<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="Class-Room-Facility" class="data-list-container">

        <vs-prompt
            :title="$t('NewFacility')"
            :accept-text="$t('Save')"
            :cancel-text="$t('Cancel')"
            @cancel="clearFacilityModal"
            @accept="SaveFacility"
            @close="clearFacilityModal"
            :is-valid="validateFacilityForm"
            :active.sync="activePrompt">
                <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent style="max-height:75vh">
                           <p>{{$t('Facility')}}</p>
          <v-select
            label="Name"
            v-model="RoomFacility.RoomFacilityID"
            :options="facilities"
            autocomplete
            class="mt-5 w-full"
            :reduce="value => value.ID"
          />


                    </form>
                </VuePerfectScrollbar>
          </vs-prompt>

      <div slot="no-body" class="tabs-container pb-6">
            <div class="tab-text">
              <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" @click="activePrompt=true">{{$t('AddFacility')}} </vs-button>

          <vs-table ref="table"   pagination :max-items="itemsPerPage"  :data="getRoomFacilities" >
            <template slot="thead">
              <vs-th sort-key="Facility">{{$t('Facility')}}</vs-th>

              <vs-th>{{$t('Action')}}</vs-th>
            </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                       <p class="product-name font-medium truncate">{{ tr.RoomFacility.Name }}</p>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editFacility(tr)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="openConfirm(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
          </vs-table>

            </div>

      </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'

import moduleRoom from "@/store/settings/room/moduleRoom.js";
import moduleRoomFacility  from "@/store/settings/roomFacility/moduleRoomFacility.js";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {

     vSelect,
     VuePerfectScrollbar
  },
  data() {
    return {
      activePrompt:false,
      selected: [],
      itemsPerPage: 5,
      isMounted: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      // Data Sidebar
      courseModel: {},
      rowDataForDelete: {},
      activeConfirm: false,
      oldRoomFacility:{},
      RoomFacility:{},
    };
  },
  computed: {

    getRoomFacilities(){
      debugger
      return this.$store.state.RoomList.RoomFacilities;

    },

     facilities() {
      return this.$store.state.roomFacilityList.roomFacilities;
    },

   isFormValid() {
      return !this.errors.any();
    },

   validateFacilityForm()
   {
     return this.RoomFacility.RoomFacilityID>0;
   }
  },

  methods: {
    editFacility(data){
       debugger
       this.RoomFacility = JSON.parse(JSON.stringify(data));
       this.oldRoomFacility=JSON.parse(JSON.stringify(data));
       this.activePrompt=true;
    },

    SaveFacility()
    {
        debugger;
        const FacilityIndex= this.facilities.findIndex((p) => p.ID == this.RoomFacility.RoomFacilityID);
        this.RoomFacility.RoomFacility= this.facilities[FacilityIndex];

           this.deletefacility(this.RoomFacility);
        if(this.oldRoomFacility.RoomFacilityID!=undefined)
        {
           this.deletefacility(this.oldRoomFacility);
           this.oldRoomFacility={};
        }
        this.$store.commit("RoomList/ADD_Facility", this.RoomFacility);
        this.clearFacilityModal();
    },

     clearFacilityModal() {
      this.RoomFacility = {}
    },

    initValues()
    {
       this.courseModel = {};
    },

    deletefacility(data) {

       this.$store.commit("RoomList/REMOVE_Facility",  data.RoomFacilityID);
    },

    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlert
      });
    },

    acceptAlert() {
      this.deletefacility(this.rowDataForDelete);
      this.$vs.notify({ time:8000,
        color: "danger",
        title: this.$t("Deletedrecord"),
       text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },


  },

  created() {
      if (!moduleRoom.isRegistered) {
      this.$store.registerModule("RoomList", moduleRoom);
      moduleRoom.isRegistered = true;
    }
      if (!moduleRoomFacility.isRegistered) {
      this.$store.registerModule("roomFacilityList", moduleRoomFacility);
      moduleRoomFacility.isRegistered = true;
    }
    this.$store.dispatch("roomFacilityList/fetchDataListItems");


  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
